<template>
  <div class="footer">
    <!--footer-->
    <!-- <div class="footer_top">
      <div class="topwrap">
        <div class="logo">
          <img src="../assets/img/logo.png" alt="user">
          <span>ABC</span>
        </div>
        <div class="social">
          <ul class="social-icons">
            <li><a :href="companyFB" target="_blank" class="social-icons__link Facebook"></a></li>
            <li><img src="../assets/img/icon-fb.png" alt="fb"></a></li>
            <li><img src="../assets/img/icon-twitter.png" alt="tw"></a></li>
            <li><img src="../assets/img/icon-ig.png" alt="ig"></a></li>
            <li><img src="../assets/img/icon-pinterest.png" alt="p"></a></li>
          </ul>
        </div>
      </div>
    </div> -->
    <div class="footer_main">
      <div class="footerGrid page-width">
        <!-- information -->
        <div>
          <h4>{{ $t('information') }}</h4>
          <ul>
            <li>
              <router-link to="/contact-us">{{ $t('contact') }}</router-link>
            </li>
            <li>
              <router-link to="/terms-of-service">{{ $t('terms') }}</router-link>
            </li>
            <li>
              <router-link to="/privacy">{{ $t('privacyTitle') }}</router-link>
            </li>
            <!-- <li>
              <router-link to="/about-us">{{ $t('aboutUs') }}</router-link>
            </li> -->
          </ul>
        </div>
        <!-- service -->
        <div>
          <h4>{{ $t('services') }}</h4>
          <ul>
            <li v-for="(item, index) in serviceSlides" data-index="index" :key="index">
              <div @click="$router.push(item.route)">
                <span>{{ $t(item.title) }}</span>
              </div>
            </li>
          </ul>
        </div>
        <!-- location -->
        <!-- <div>
          <h4>{{ $t('locations') }}</h4>
          <ul>
            <li>
              <span>Location1</span>
            </li>
            <li>
              <span>Location2</span>
            </li>
            <li>
              <span>Location3</span>
            </li>
            <li>
              <span>Location4</span>
            </li>
          </ul>
        </div> -->
        <!-- about us -->
        <div>
          <h4>{{ $t('aboutUs') }}</h4>
          <ul>
            <li>
              <span>{{ $t('address') }}: 2254 Valdina street Dallas, TX 75207</span>
            </li>
            <li>
              <span>{{ $t('phoneNumber') }}: +1(956) 577 1268</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!--end footer-->

    <div class="payment">
      <img src="../assets/img/payment.png" alt="">
    </div>
  </div>
</template>

<script>           
import { Config } from '../../config/default';
import { mapState } from 'vuex'
export default {
  name: "footer",
  data() {
    return{
      companyFB: Config.COMPANY_FB,
      companyIG: Config.COMPANY_IG,
      serviceSlides: [
        { title: "header1", route: "/inbound" },
        { title: "header2", route: "/outboundInv"}, // 海外仓
        { title: "header3", route: "/outboundNoInv"}, // 卡派打單
        { title: "header4", route: "/upsFedex"}, // 快递打单
        { title: "aboutUs", oute: "/aboutUs"}, // 关于我们
      ],
    }
  },
  computed: mapState({
    loggedIn: state => state.auth.loggedIn
  })
}
</script>

<style scoped lang="less">
@import "../assets/css/footer.less";
</style>



// WEBPACK FOOTER //
// src/components/footer.vue